import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import {
	fetchV2TournamentApplied,
	fetchV2TournamentSetupMy,
	fetchV2TournamentProgressMy,
	fetchV2TournamentFinishedMy,
	fetchV2TournamentIdDetailIncomplete,
	fetchV2TournamentIdDancesWeb,
	fetchV2TournamentIdLocalizations,
	fetchV2TournamentBannerList,
	fetchV2TournamentIdFilterStatistics,
	fetchV2TournamentIdManageRegister,
	fetchV2TournamentIdManageQualifier,
	fetchV2TournamentIdManageSelecting,
	fetchV2TournamentIdManageSelectingNone,
	fetchV2TournamentIdManageSelectingSelected,
	fetchV2TournamentIdManageSelectingMatched,
	fetchV2TournamentIdManagePrematch,
	fetchV2TournamentIdManageLive,
	fetchV2TournamentIdManageFinished,
	fetchV2TournamentIdRegisterNotificationStatus,
	fetchV2TournamentIdParticipants,
	fetchV2TournamentIdApplicants,
	fetchV2TournamentIdNominees,
	fetchV2TournamentIdRoundIdParticipants,
	fetchV2TournamentIdRoundIdMatches,
	fetchV2TournamentIdRounds,
	fetchV2TournamentIdDances,
	fetchV2TournamentIdNations,
	fetchV2TournamentIdInvites,
	fetchV2TournamentMain,
	fetchV2TournamentParticipated,
	fetchV2TournamentCreated,
	fetchV2TournamentLiveMatch,
	fetchV2TournamentParticipable,
	fetchV2TournamentSpecificStatus,
	fetchV2TournamentFinishedDetail,
	fetchV2TournamentRecommend,
	fetchV2TournamentIdDetail,
	fetchV2TournamentIdTryoutRank,
	fetchV2TournamentInboxStatus,
	fetchV2TournamentActivityInboxes,
	fetchV2TournamentGameInboxes,
	fetchV2TournamentParentConsent,
	fetchV2TournamentIdDynamiclink,
	fetchV2TournamentParticipationsUserId,
	fetchV2TournamentCreatedSimpleUserId,
	fetchV2TournamentCreatedMainUserId,
	fetchV2TournamentCreatedDetailUserId,
	fetchV2TournamentIdLiveData,
	fetchV2TournamentInternalSearch,
} from './v2_tournamentAPI';
import {
	TournamentV2Controller_getAppliedTournaments_Params,
	TournamentV2Controller_getAppliedTournaments_Response,
	TournamentV2Controller_getMySetupTournaments_Params,
	TournamentV2Controller_getMySetupTournaments_Response,
	TournamentV2Controller_getMyProgressTournaments_Params,
	TournamentV2Controller_getMyProgressTournaments_Response,
	TournamentV2Controller_getMyFinishedTournaments_Params,
	TournamentV2Controller_getMyFinishedTournaments_Response,
	TournamentV2Controller_getIncompleteTournamentDetail_Params,
	TournamentV2Controller_getIncompleteTournamentDetail_Response,
	TournamentV2Controller_getTournamentDancesForWeb_Params,
	TournamentV2Controller_getTournamentDancesForWeb_Response,
	TournamentV2Controller_getTournamentLocalizations_Params,
	TournamentV2Controller_getTournamentLocalizations_Response,
	TournamentV2Controller_getTournamentBanners_Params,
	TournamentV2Controller_getTournamentBanners_Response,
	TournamentV2Controller_getUserFilterStatistics_Params,
	TournamentV2Controller_getUserFilterStatistics_Response,
	TournamentV2Controller_getManageRegisterTournament_Params,
	TournamentV2Controller_getManageRegisterTournament_Response,
	TournamentV2Controller_getManageQaulifierTournament_Params,
	TournamentV2Controller_getManageQaulifierTournament_Response,
	TournamentV2Controller_getManageSelectingTournament_Params,
	TournamentV2Controller_getManageSelectingTournament_Response,
	TournamentV2Controller_getManageSelectingNoneTournament_Params,
	TournamentV2Controller_getManageSelectingNoneTournament_Response,
	TournamentV2Controller_getManageSelectingSelectedTournament_Params,
	TournamentV2Controller_getManageSelectingSelectedTournament_Response,
	TournamentV2Controller_getManageSelectingMatchedTournament_Params,
	TournamentV2Controller_getManageSelectingMatchedTournament_Response,
	TournamentV2Controller_getManagePrematchTournament_Params,
	TournamentV2Controller_getManagePrematchTournament_Response,
	TournamentV2Controller_getManageLiveTournament_Params,
	TournamentV2Controller_getManageLiveTournament_Response,
	TournamentV2Controller_getManageFinishedTournament_Params,
	TournamentV2Controller_getManageFinishedTournament_Response,
	TournamentV2Controller_getRegisterNotificationStatus_Params,
	TournamentV2Controller_getRegisterNotificationStatus_Response,
	TournamentV2Controller_getTournamentParticipants_Params,
	TournamentV2Controller_getTournamentParticipants_Response,
	TournamentV2Controller_getTournamentApplicants_Params,
	TournamentV2Controller_getTournamentApplicants_Response,
	TournamentV2Controller_getTournamentNominees_Params,
	TournamentV2Controller_getTournamentNominees_Response,
	TournamentV2Controller_getRoundParticipants_Params,
	TournamentV2Controller_getRoundParticipants_Response,
	TournamentV2Controller_getRoundMatches_Params,
	TournamentV2Controller_getRoundMatches_Response,
	TournamentV2Controller_getTournamentRounds_Params,
	TournamentV2Controller_getTournamentRounds_Response,
	TournamentV2Controller_getTournamentDances_Params,
	TournamentV2Controller_getTournamentDances_Response,
	TournamentV2Controller_getTournamentNations_Params,
	TournamentV2Controller_getTournamentNations_Response,
	TournamentV2Controller_getTournamentInvites_Params,
	TournamentV2Controller_getTournamentInvites_Response,
	TournamentV2Controller_getMainTournaments_Params,
	TournamentV2Controller_getMainTournaments_Response,
	TournamentV2Controller_getParticipatedTournaments_Params,
	TournamentV2Controller_getParticipatedTournaments_Response,
	TournamentV2Controller_getCreatedTournaments_Params,
	TournamentV2Controller_getCreatedTournaments_Response,
	TournamentV2Controller_getLiveTournamentMatch_Params,
	TournamentV2Controller_getLiveTournamentMatch_Response,
	TournamentV2Controller_getParticipableTournaments_Params,
	TournamentV2Controller_getParticipableTournaments_Response,
	TournamentV2Controller_getSpecificStatusTournaments_Params,
	TournamentV2Controller_getSpecificStatusTournaments_Response,
	TournamentV2Controller_getFinishedTournamentDetail_Params,
	TournamentV2Controller_getFinishedTournamentDetail_Response,
	TournamentV2Controller_getRecommendedTournament_Params,
	TournamentV2Controller_getRecommendedTournament_Response,
	TournamentV2Controller_getTournamentDetail_Params,
	TournamentV2Controller_getTournamentDetail_Response,
	TournamentV2Controller_getTournamentTryoutRanking_Params,
	TournamentV2Controller_getTournamentTryoutRanking_Response,
	TournamentV2Controller_getTournamentStatus_Params,
	TournamentV2Controller_getTournamentStatus_Response,
	TournamentV2Controller_getActivityInbox_Params,
	TournamentV2Controller_getActivityInbox_Response,
	TournamentV2Controller_getGameInboxes_Params,
	TournamentV2Controller_getGameInboxes_Response,
	TournamentV2Controller_checkParentConsent_Params,
	TournamentV2Controller_checkParentConsent_Response,
	TournamentV2Controller_shareTournament_Params,
	TournamentV2Controller_shareTournament_Response,
	TournamentV2Controller_getParticipatedTournamentsInfo_Params,
	TournamentV2Controller_getParticipatedTournamentsInfo_Response,
	TournamentV2Controller_getCreatedTournamentsInfo_Params,
	TournamentV2Controller_getCreatedTournamentsInfo_Response,
	TournamentV2Controller_getUserCreatedMainTournaments_Params,
	TournamentV2Controller_getUserCreatedMainTournaments_Response,
	TournamentV2Controller_getUserCreatedTournamentsDetail_Params,
	TournamentV2Controller_getUserCreatedTournamentsDetail_Response,
	TournamentV2Controller_getTournamentLiveData_Params,
	TournamentV2Controller_getTournamentLiveData_Response,
	TournamentV2Controller_internalSearchTournament_Params,
	TournamentV2Controller_internalSearchTournament_Response,
} from '@/domains/content/types/validated';

export const useFetchV2TournamentAppliedQuery = (
	params: TournamentV2Controller_getAppliedTournaments_Params,
	enabled?: boolean
): UseQueryResult<TournamentV2Controller_getAppliedTournaments_Response, Error> => {
	return useQuery({
		queryKey: ['fetchV2TournamentApplied', params],
		queryFn: () => fetchV2TournamentApplied(params),
		enabled: enabled,
		throwOnError: (error: Error) => {
			console.error('[Query Error]', error);
			toast.error(error.message || 'Query failed');
			return true;
		},
	});
};

export const useFetchV2TournamentSetupMyQuery = (
	params: TournamentV2Controller_getMySetupTournaments_Params,
	enabled?: boolean
): UseQueryResult<TournamentV2Controller_getMySetupTournaments_Response, Error> => {
	return useQuery({
		queryKey: ['fetchV2TournamentSetupMy', params],
		queryFn: () => fetchV2TournamentSetupMy(params),
		enabled: enabled,
		throwOnError: (error: Error) => {
			console.error('[Query Error]', error);
			toast.error(error.message || 'Query failed');
			return true;
		},
	});
};

export const useFetchV2TournamentProgressMyQuery = (
	params: TournamentV2Controller_getMyProgressTournaments_Params,
	enabled?: boolean
): UseQueryResult<TournamentV2Controller_getMyProgressTournaments_Response, Error> => {
	return useQuery({
		queryKey: ['fetchV2TournamentProgressMy', params],
		queryFn: () => fetchV2TournamentProgressMy(params),
		enabled: enabled,
		throwOnError: (error: Error) => {
			console.error('[Query Error]', error);
			toast.error(error.message || 'Query failed');
			return true;
		},
	});
};

export const useFetchV2TournamentFinishedMyQuery = (
	params: TournamentV2Controller_getMyFinishedTournaments_Params,
	enabled?: boolean
): UseQueryResult<TournamentV2Controller_getMyFinishedTournaments_Response, Error> => {
	return useQuery({
		queryKey: ['fetchV2TournamentFinishedMy', params],
		queryFn: () => fetchV2TournamentFinishedMy(params),
		enabled: enabled,
		throwOnError: (error: Error) => {
			console.error('[Query Error]', error);
			toast.error(error.message || 'Query failed');
			return true;
		},
	});
};

export const useFetchV2TournamentIdDetailIncompleteQuery = (
	params: TournamentV2Controller_getIncompleteTournamentDetail_Params,
	enabled?: boolean
): UseQueryResult<TournamentV2Controller_getIncompleteTournamentDetail_Response, Error> => {
	return useQuery({
		queryKey: ['fetchV2TournamentIdDetailIncomplete', params],
		queryFn: () => fetchV2TournamentIdDetailIncomplete(params),
		enabled: enabled,
		throwOnError: (error: Error) => {
			console.error('[Query Error]', error);
			toast.error(error.message || 'Query failed');
			return true;
		},
	});
};

export const useFetchV2TournamentIdDancesWebQuery = (
	params: TournamentV2Controller_getTournamentDancesForWeb_Params,
	enabled?: boolean
): UseQueryResult<TournamentV2Controller_getTournamentDancesForWeb_Response, Error> => {
	return useQuery({
		queryKey: ['fetchV2TournamentIdDancesWeb', params],
		queryFn: () => fetchV2TournamentIdDancesWeb(params),
		enabled: enabled,
		throwOnError: (error: Error) => {
			console.error('[Query Error]', error);
			toast.error(error.message || 'Query failed');
			return true;
		},
	});
};

export const useFetchV2TournamentIdLocalizationsQuery = (
	params: TournamentV2Controller_getTournamentLocalizations_Params,
	enabled?: boolean
): UseQueryResult<TournamentV2Controller_getTournamentLocalizations_Response, Error> => {
	return useQuery({
		queryKey: ['fetchV2TournamentIdLocalizations', params],
		queryFn: () => fetchV2TournamentIdLocalizations(params),
		enabled: enabled,
		throwOnError: (error: Error) => {
			console.error('[Query Error]', error);
			toast.error(error.message || 'Query failed');
			return true;
		},
	});
};

export const useFetchV2TournamentBannerListQuery = (
	params: TournamentV2Controller_getTournamentBanners_Params,
	enabled?: boolean
): UseQueryResult<TournamentV2Controller_getTournamentBanners_Response, Error> => {
	return useQuery({
		queryKey: ['fetchV2TournamentBannerList', params],
		queryFn: () => fetchV2TournamentBannerList(params),
		enabled: enabled,
		throwOnError: (error: Error) => {
			console.error('[Query Error]', error);
			toast.error(error.message || 'Query failed');
			return true;
		},
	});
};

export const useFetchV2TournamentIdFilterStatisticsQuery = (
	params: TournamentV2Controller_getUserFilterStatistics_Params,
	enabled?: boolean
): UseQueryResult<TournamentV2Controller_getUserFilterStatistics_Response, Error> => {
	return useQuery({
		queryKey: ['fetchV2TournamentIdFilterStatistics', params],
		queryFn: () => fetchV2TournamentIdFilterStatistics(params),
		enabled: enabled,
		throwOnError: (error: Error) => {
			console.error('[Query Error]', error);
			toast.error(error.message || 'Query failed');
			return true;
		},
	});
};

export const useFetchV2TournamentIdManageRegisterQuery = (
	params: TournamentV2Controller_getManageRegisterTournament_Params,
	enabled?: boolean
): UseQueryResult<TournamentV2Controller_getManageRegisterTournament_Response, Error> => {
	return useQuery({
		queryKey: ['fetchV2TournamentIdManageRegister', params],
		queryFn: () => fetchV2TournamentIdManageRegister(params),
		enabled: enabled,
		throwOnError: (error: Error) => {
			console.error('[Query Error]', error);
			toast.error(error.message || 'Query failed');
			return true;
		},
	});
};

export const useFetchV2TournamentIdManageQualifierQuery = (
	params: TournamentV2Controller_getManageQaulifierTournament_Params,
	enabled?: boolean
): UseQueryResult<TournamentV2Controller_getManageQaulifierTournament_Response, Error> => {
	return useQuery({
		queryKey: ['fetchV2TournamentIdManageQualifier', params],
		queryFn: () => fetchV2TournamentIdManageQualifier(params),
		enabled: enabled,
		throwOnError: (error: Error) => {
			console.error('[Query Error]', error);
			toast.error(error.message || 'Query failed');
			return true;
		},
	});
};

export const useFetchV2TournamentIdManageSelectingQuery = (
	params: TournamentV2Controller_getManageSelectingTournament_Params,
	enabled?: boolean
): UseQueryResult<TournamentV2Controller_getManageSelectingTournament_Response, Error> => {
	return useQuery({
		queryKey: ['fetchV2TournamentIdManageSelecting', params],
		queryFn: () => fetchV2TournamentIdManageSelecting(params),
		enabled: enabled,
		throwOnError: (error: Error) => {
			console.error('[Query Error]', error);
			toast.error(error.message || 'Query failed');
			return true;
		},
	});
};

export const useFetchV2TournamentIdManageSelectingNoneQuery = (
	params: TournamentV2Controller_getManageSelectingNoneTournament_Params,
	enabled?: boolean
): UseQueryResult<TournamentV2Controller_getManageSelectingNoneTournament_Response, Error> => {
	return useQuery({
		queryKey: ['fetchV2TournamentIdManageSelectingNone', params],
		queryFn: () => fetchV2TournamentIdManageSelectingNone(params),
		enabled: enabled,
		throwOnError: (error: Error) => {
			console.error('[Query Error]', error);
			toast.error(error.message || 'Query failed');
			return true;
		},
	});
};

export const useFetchV2TournamentIdManageSelectingSelectedQuery = (
	params: TournamentV2Controller_getManageSelectingSelectedTournament_Params,
	enabled?: boolean
): UseQueryResult<TournamentV2Controller_getManageSelectingSelectedTournament_Response, Error> => {
	return useQuery({
		queryKey: ['fetchV2TournamentIdManageSelectingSelected', params],
		queryFn: () => fetchV2TournamentIdManageSelectingSelected(params),
		enabled: enabled,
		throwOnError: (error: Error) => {
			console.error('[Query Error]', error);
			toast.error(error.message || 'Query failed');
			return true;
		},
	});
};

export const useFetchV2TournamentIdManageSelectingMatchedQuery = (
	params: TournamentV2Controller_getManageSelectingMatchedTournament_Params,
	enabled?: boolean
): UseQueryResult<TournamentV2Controller_getManageSelectingMatchedTournament_Response, Error> => {
	return useQuery({
		queryKey: ['fetchV2TournamentIdManageSelectingMatched', params],
		queryFn: () => fetchV2TournamentIdManageSelectingMatched(params),
		enabled: enabled,
		throwOnError: (error: Error) => {
			console.error('[Query Error]', error);
			toast.error(error.message || 'Query failed');
			return true;
		},
	});
};

export const useFetchV2TournamentIdManagePrematchQuery = (
	params: TournamentV2Controller_getManagePrematchTournament_Params,
	enabled?: boolean
): UseQueryResult<TournamentV2Controller_getManagePrematchTournament_Response, Error> => {
	return useQuery({
		queryKey: ['fetchV2TournamentIdManagePrematch', params],
		queryFn: () => fetchV2TournamentIdManagePrematch(params),
		enabled: enabled,
		throwOnError: (error: Error) => {
			console.error('[Query Error]', error);
			toast.error(error.message || 'Query failed');
			return true;
		},
	});
};

export const useFetchV2TournamentIdManageLiveQuery = (
	params: TournamentV2Controller_getManageLiveTournament_Params,
	enabled?: boolean
): UseQueryResult<TournamentV2Controller_getManageLiveTournament_Response, Error> => {
	return useQuery({
		queryKey: ['fetchV2TournamentIdManageLive', params],
		queryFn: () => fetchV2TournamentIdManageLive(params),
		enabled: enabled,
		throwOnError: (error: Error) => {
			console.error('[Query Error]', error);
			toast.error(error.message || 'Query failed');
			return true;
		},
	});
};

export const useFetchV2TournamentIdManageFinishedQuery = (
	params: TournamentV2Controller_getManageFinishedTournament_Params,
	enabled?: boolean
): UseQueryResult<TournamentV2Controller_getManageFinishedTournament_Response, Error> => {
	return useQuery({
		queryKey: ['fetchV2TournamentIdManageFinished', params],
		queryFn: () => fetchV2TournamentIdManageFinished(params),
		enabled: enabled,
		throwOnError: (error: Error) => {
			console.error('[Query Error]', error);
			toast.error(error.message || 'Query failed');
			return true;
		},
	});
};

export const useFetchV2TournamentIdRegisterNotificationStatusQuery = (
	params: TournamentV2Controller_getRegisterNotificationStatus_Params,
	enabled?: boolean
): UseQueryResult<TournamentV2Controller_getRegisterNotificationStatus_Response, Error> => {
	return useQuery({
		queryKey: ['fetchV2TournamentIdRegisterNotificationStatus', params],
		queryFn: () => fetchV2TournamentIdRegisterNotificationStatus(params),
		enabled: enabled,
		throwOnError: (error: Error) => {
			console.error('[Query Error]', error);
			toast.error(error.message || 'Query failed');
			return true;
		},
	});
};

export const useFetchV2TournamentIdParticipantsQuery = (
	params: TournamentV2Controller_getTournamentParticipants_Params,
	enabled?: boolean
): UseQueryResult<TournamentV2Controller_getTournamentParticipants_Response, Error> => {
	return useQuery({
		queryKey: ['fetchV2TournamentIdParticipants', params],
		queryFn: () => fetchV2TournamentIdParticipants(params),
		enabled: enabled,
		throwOnError: (error: Error) => {
			console.error('[Query Error]', error);
			toast.error(error.message || 'Query failed');
			return true;
		},
	});
};

export const useFetchV2TournamentIdApplicantsQuery = (
	params: TournamentV2Controller_getTournamentApplicants_Params,
	enabled?: boolean
): UseQueryResult<TournamentV2Controller_getTournamentApplicants_Response, Error> => {
	return useQuery({
		queryKey: ['fetchV2TournamentIdApplicants', params],
		queryFn: () => fetchV2TournamentIdApplicants(params),
		enabled: enabled,
		throwOnError: (error: Error) => {
			console.error('[Query Error]', error);
			toast.error(error.message || 'Query failed');
			return true;
		},
	});
};

export const useFetchV2TournamentIdNomineesQuery = (
	params: TournamentV2Controller_getTournamentNominees_Params,
	enabled?: boolean
): UseQueryResult<TournamentV2Controller_getTournamentNominees_Response, Error> => {
	return useQuery({
		queryKey: ['fetchV2TournamentIdNominees', params],
		queryFn: () => fetchV2TournamentIdNominees(params),
		enabled: enabled,
		throwOnError: (error: Error) => {
			console.error('[Query Error]', error);
			toast.error(error.message || 'Query failed');
			return true;
		},
	});
};

export const useFetchV2TournamentIdRoundIdParticipantsQuery = (
	params: TournamentV2Controller_getRoundParticipants_Params,
	enabled?: boolean
): UseQueryResult<TournamentV2Controller_getRoundParticipants_Response, Error> => {
	return useQuery({
		queryKey: ['fetchV2TournamentIdRoundIdParticipants', params],
		queryFn: () => fetchV2TournamentIdRoundIdParticipants(params),
		enabled: enabled,
		throwOnError: (error: Error) => {
			console.error('[Query Error]', error);
			toast.error(error.message || 'Query failed');
			return true;
		},
	});
};

export const useFetchV2TournamentIdRoundIdMatchesQuery = (
	params: TournamentV2Controller_getRoundMatches_Params,
	enabled?: boolean
): UseQueryResult<TournamentV2Controller_getRoundMatches_Response, Error> => {
	return useQuery({
		queryKey: ['fetchV2TournamentIdRoundIdMatches', params],
		queryFn: () => fetchV2TournamentIdRoundIdMatches(params),
		enabled: enabled,
		throwOnError: (error: Error) => {
			console.error('[Query Error]', error);
			toast.error(error.message || 'Query failed');
			return true;
		},
	});
};

export const useFetchV2TournamentIdRoundsQuery = (
	params: TournamentV2Controller_getTournamentRounds_Params,
	enabled?: boolean
): UseQueryResult<TournamentV2Controller_getTournamentRounds_Response, Error> => {
	return useQuery({
		queryKey: ['fetchV2TournamentIdRounds', params],
		queryFn: () => fetchV2TournamentIdRounds(params),
		enabled: enabled,
		throwOnError: (error: Error) => {
			console.error('[Query Error]', error);
			toast.error(error.message || 'Query failed');
			return true;
		},
	});
};

export const useFetchV2TournamentIdDancesQuery = (
	params: TournamentV2Controller_getTournamentDances_Params,
	enabled?: boolean
): UseQueryResult<TournamentV2Controller_getTournamentDances_Response, Error> => {
	return useQuery({
		queryKey: ['fetchV2TournamentIdDances', params],
		queryFn: () => fetchV2TournamentIdDances(params),
		enabled: enabled,
		throwOnError: (error: Error) => {
			console.error('[Query Error]', error);
			toast.error(error.message || 'Query failed');
			return true;
		},
	});
};

export const useFetchV2TournamentIdNationsQuery = (
	params: TournamentV2Controller_getTournamentNations_Params,
	enabled?: boolean
): UseQueryResult<TournamentV2Controller_getTournamentNations_Response, Error> => {
	return useQuery({
		queryKey: ['fetchV2TournamentIdNations', params],
		queryFn: () => fetchV2TournamentIdNations(params),
		enabled: enabled,
		throwOnError: (error: Error) => {
			console.error('[Query Error]', error);
			toast.error(error.message || 'Query failed');
			return true;
		},
	});
};

export const useFetchV2TournamentIdInvitesQuery = (
	params: TournamentV2Controller_getTournamentInvites_Params,
	enabled?: boolean
): UseQueryResult<TournamentV2Controller_getTournamentInvites_Response, Error> => {
	return useQuery({
		queryKey: ['fetchV2TournamentIdInvites', params],
		queryFn: () => fetchV2TournamentIdInvites(params),
		enabled: enabled,
		throwOnError: (error: Error) => {
			console.error('[Query Error]', error);
			toast.error(error.message || 'Query failed');
			return true;
		},
	});
};

export const useFetchV2TournamentMainQuery = (
	params: TournamentV2Controller_getMainTournaments_Params,
	enabled?: boolean
): UseQueryResult<TournamentV2Controller_getMainTournaments_Response, Error> => {
	return useQuery({
		queryKey: ['fetchV2TournamentMain', params],
		queryFn: () => fetchV2TournamentMain(params),
		enabled: enabled,
		throwOnError: (error: Error) => {
			console.error('[Query Error]', error);
			toast.error(error.message || 'Query failed');
			return true;
		},
	});
};

export const useFetchV2TournamentParticipatedQuery = (
	params: TournamentV2Controller_getParticipatedTournaments_Params,
	enabled?: boolean
): UseQueryResult<TournamentV2Controller_getParticipatedTournaments_Response, Error> => {
	return useQuery({
		queryKey: ['fetchV2TournamentParticipated', params],
		queryFn: () => fetchV2TournamentParticipated(params),
		enabled: enabled,
		throwOnError: (error: Error) => {
			console.error('[Query Error]', error);
			toast.error(error.message || 'Query failed');
			return true;
		},
	});
};

export const useFetchV2TournamentCreatedQuery = (
	params: TournamentV2Controller_getCreatedTournaments_Params,
	enabled?: boolean
): UseQueryResult<TournamentV2Controller_getCreatedTournaments_Response, Error> => {
	return useQuery({
		queryKey: ['fetchV2TournamentCreated', params],
		queryFn: () => fetchV2TournamentCreated(params),
		enabled: enabled,
		throwOnError: (error: Error) => {
			console.error('[Query Error]', error);
			toast.error(error.message || 'Query failed');
			return true;
		},
	});
};

export const useFetchV2TournamentLiveMatchQuery = (
	params: TournamentV2Controller_getLiveTournamentMatch_Params,
	enabled?: boolean
): UseQueryResult<TournamentV2Controller_getLiveTournamentMatch_Response, Error> => {
	return useQuery({
		queryKey: ['fetchV2TournamentLiveMatch', params],
		queryFn: () => fetchV2TournamentLiveMatch(params),
		enabled: enabled,
		throwOnError: (error: Error) => {
			console.error('[Query Error]', error);
			toast.error(error.message || 'Query failed');
			return true;
		},
	});
};

export const useFetchV2TournamentParticipableQuery = (
	params: TournamentV2Controller_getParticipableTournaments_Params,
	enabled?: boolean
): UseQueryResult<TournamentV2Controller_getParticipableTournaments_Response, Error> => {
	return useQuery({
		queryKey: ['fetchV2TournamentParticipable', params],
		queryFn: () => fetchV2TournamentParticipable(params),
		enabled: enabled,
		throwOnError: (error: Error) => {
			console.error('[Query Error]', error);
			toast.error(error.message || 'Query failed');
			return true;
		},
	});
};

export const useFetchV2TournamentSpecificStatusQuery = (
	params: TournamentV2Controller_getSpecificStatusTournaments_Params,
	enabled?: boolean
): UseQueryResult<TournamentV2Controller_getSpecificStatusTournaments_Response, Error> => {
	return useQuery({
		queryKey: ['fetchV2TournamentSpecificStatus', params],
		queryFn: () => fetchV2TournamentSpecificStatus(params),
		enabled: enabled,
		throwOnError: (error: Error) => {
			console.error('[Query Error]', error);
			toast.error(error.message || 'Query failed');
			return true;
		},
	});
};

export const useFetchV2TournamentFinishedDetailQuery = (
	params: TournamentV2Controller_getFinishedTournamentDetail_Params,
	enabled?: boolean
): UseQueryResult<TournamentV2Controller_getFinishedTournamentDetail_Response, Error> => {
	return useQuery({
		queryKey: ['fetchV2TournamentFinishedDetail', params],
		queryFn: () => fetchV2TournamentFinishedDetail(params),
		enabled: enabled,
		throwOnError: (error: Error) => {
			console.error('[Query Error]', error);
			toast.error(error.message || 'Query failed');
			return true;
		},
	});
};

export const useFetchV2TournamentRecommendQuery = (
	params: TournamentV2Controller_getRecommendedTournament_Params,
	enabled?: boolean
): UseQueryResult<TournamentV2Controller_getRecommendedTournament_Response, Error> => {
	return useQuery({
		queryKey: ['fetchV2TournamentRecommend', params],
		queryFn: () => fetchV2TournamentRecommend(params),
		enabled: enabled,
		throwOnError: (error: Error) => {
			console.error('[Query Error]', error);
			toast.error(error.message || 'Query failed');
			return true;
		},
	});
};

export const useFetchV2TournamentIdDetailQuery = (
	params: TournamentV2Controller_getTournamentDetail_Params,
	enabled?: boolean
): UseQueryResult<TournamentV2Controller_getTournamentDetail_Response, Error> => {
	return useQuery({
		queryKey: ['fetchV2TournamentIdDetail', params],
		queryFn: () => fetchV2TournamentIdDetail(params),
		enabled: enabled,
		throwOnError: (error: Error) => {
			console.error('[Query Error]', error);
			toast.error(error.message || 'Query failed');
			return true;
		},
	});
};

export const useFetchV2TournamentIdTryoutRankQuery = (
	params: TournamentV2Controller_getTournamentTryoutRanking_Params,
	enabled?: boolean
): UseQueryResult<TournamentV2Controller_getTournamentTryoutRanking_Response, Error> => {
	return useQuery({
		queryKey: ['fetchV2TournamentIdTryoutRank', params],
		queryFn: () => fetchV2TournamentIdTryoutRank(params),
		enabled: enabled,
		throwOnError: (error: Error) => {
			console.error('[Query Error]', error);
			toast.error(error.message || 'Query failed');
			return true;
		},
	});
};

export const useFetchV2TournamentInboxStatusQuery = (
	params: TournamentV2Controller_getTournamentStatus_Params,
	enabled?: boolean
): UseQueryResult<TournamentV2Controller_getTournamentStatus_Response, Error> => {
	return useQuery({
		queryKey: ['fetchV2TournamentInboxStatus', params],
		queryFn: () => fetchV2TournamentInboxStatus(params),
		enabled: enabled,
		throwOnError: (error: Error) => {
			console.error('[Query Error]', error);
			toast.error(error.message || 'Query failed');
			return true;
		},
	});
};

export const useFetchV2TournamentActivityInboxesQuery = (
	params: TournamentV2Controller_getActivityInbox_Params,
	enabled?: boolean
): UseQueryResult<TournamentV2Controller_getActivityInbox_Response, Error> => {
	return useQuery({
		queryKey: ['fetchV2TournamentActivityInboxes', params],
		queryFn: () => fetchV2TournamentActivityInboxes(params),
		enabled: enabled,
		throwOnError: (error: Error) => {
			console.error('[Query Error]', error);
			toast.error(error.message || 'Query failed');
			return true;
		},
	});
};

export const useFetchV2TournamentGameInboxesQuery = (
	params: TournamentV2Controller_getGameInboxes_Params,
	enabled?: boolean
): UseQueryResult<TournamentV2Controller_getGameInboxes_Response, Error> => {
	return useQuery({
		queryKey: ['fetchV2TournamentGameInboxes', params],
		queryFn: () => fetchV2TournamentGameInboxes(params),
		enabled: enabled,
		throwOnError: (error: Error) => {
			console.error('[Query Error]', error);
			toast.error(error.message || 'Query failed');
			return true;
		},
	});
};

export const useFetchV2TournamentParentConsentQuery = (
	params: TournamentV2Controller_checkParentConsent_Params,
	enabled?: boolean
): UseQueryResult<TournamentV2Controller_checkParentConsent_Response, Error> => {
	return useQuery({
		queryKey: ['fetchV2TournamentParentConsent', params],
		queryFn: () => fetchV2TournamentParentConsent(params),
		enabled: enabled,
		throwOnError: (error: Error) => {
			console.error('[Query Error]', error);
			toast.error(error.message || 'Query failed');
			return true;
		},
	});
};

export const useFetchV2TournamentIdDynamiclinkQuery = (
	params: TournamentV2Controller_shareTournament_Params,
	enabled?: boolean
): UseQueryResult<TournamentV2Controller_shareTournament_Response, Error> => {
	return useQuery({
		queryKey: ['fetchV2TournamentIdDynamiclink', params],
		queryFn: () => fetchV2TournamentIdDynamiclink(params),
		enabled: enabled,
		throwOnError: (error: Error) => {
			console.error('[Query Error]', error);
			toast.error(error.message || 'Query failed');
			return true;
		},
	});
};

export const useFetchV2TournamentParticipationsUserIdQuery = (
	params: TournamentV2Controller_getParticipatedTournamentsInfo_Params,
	enabled?: boolean
): UseQueryResult<TournamentV2Controller_getParticipatedTournamentsInfo_Response, Error> => {
	return useQuery({
		queryKey: ['fetchV2TournamentParticipationsUserId', params],
		queryFn: () => fetchV2TournamentParticipationsUserId(params),
		enabled: enabled,
		throwOnError: (error: Error) => {
			console.error('[Query Error]', error);
			toast.error(error.message || 'Query failed');
			return true;
		},
	});
};

export const useFetchV2TournamentCreatedSimpleUserIdQuery = (
	params: TournamentV2Controller_getCreatedTournamentsInfo_Params,
	enabled?: boolean
): UseQueryResult<TournamentV2Controller_getCreatedTournamentsInfo_Response, Error> => {
	return useQuery({
		queryKey: ['fetchV2TournamentCreatedSimpleUserId', params],
		queryFn: () => fetchV2TournamentCreatedSimpleUserId(params),
		enabled: enabled,
		throwOnError: (error: Error) => {
			console.error('[Query Error]', error);
			toast.error(error.message || 'Query failed');
			return true;
		},
	});
};

export const useFetchV2TournamentCreatedMainUserIdQuery = (
	params: TournamentV2Controller_getUserCreatedMainTournaments_Params,
	enabled?: boolean
): UseQueryResult<TournamentV2Controller_getUserCreatedMainTournaments_Response, Error> => {
	return useQuery({
		queryKey: ['fetchV2TournamentCreatedMainUserId', params],
		queryFn: () => fetchV2TournamentCreatedMainUserId(params),
		enabled: enabled,
		throwOnError: (error: Error) => {
			console.error('[Query Error]', error);
			toast.error(error.message || 'Query failed');
			return true;
		},
	});
};

export const useFetchV2TournamentCreatedDetailUserIdQuery = (
	params: TournamentV2Controller_getUserCreatedTournamentsDetail_Params,
	enabled?: boolean
): UseQueryResult<TournamentV2Controller_getUserCreatedTournamentsDetail_Response, Error> => {
	return useQuery({
		queryKey: ['fetchV2TournamentCreatedDetailUserId', params],
		queryFn: () => fetchV2TournamentCreatedDetailUserId(params),
		enabled: enabled,
		throwOnError: (error: Error) => {
			console.error('[Query Error]', error);
			toast.error(error.message || 'Query failed');
			return true;
		},
	});
};

export const useFetchV2TournamentIdLiveDataQuery = (
	params: TournamentV2Controller_getTournamentLiveData_Params,
	enabled?: boolean
): UseQueryResult<TournamentV2Controller_getTournamentLiveData_Response, Error> => {
	return useQuery({
		queryKey: ['fetchV2TournamentIdLiveData', params],
		queryFn: () => fetchV2TournamentIdLiveData(params),
		enabled: enabled,
		throwOnError: (error: Error) => {
			console.error('[Query Error]', error);
			toast.error(error.message || 'Query failed');
			return true;
		},
	});
};

export const useFetchV2TournamentInternalSearchQuery = (
	params: TournamentV2Controller_internalSearchTournament_Params,
	enabled?: boolean
): UseQueryResult<TournamentV2Controller_internalSearchTournament_Response, Error> => {
	return useQuery({
		queryKey: ['fetchV2TournamentInternalSearch', params],
		queryFn: () => fetchV2TournamentInternalSearch(params),
		enabled: enabled,
		throwOnError: (error: Error) => {
			console.error('[Query Error]', error);
			toast.error(error.message || 'Query failed');
			return true;
		},
	});
};
